"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availabilityByPropertyId = void 0;
const filterEvents = (stateList, newList) => {
    const currentIds = stateList.map((e) => e.id);
    return [...stateList, ...newList.filter((e) => !currentIds.includes(e.id))];
};
exports.availabilityByPropertyId = (state = {}, action = {}) => {
    switch (action.type) {
        case 'AVAILABILITY_GET_BY_PROPERTY_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: action.payload.availabilityEvents });
        case 'AVAILABILITY_EVENT_CREATE_RECEIVE':
        case 'BLOCK_BY_DATE_RANGE_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: filterEvents(state[action.payload.propertyId] || [], action.payload.availabilityEvents) });
        case 'RESOLVE_EVENTS_RECEIVE':
            const { deleted, updated, created } = action.payload;
            const additions = updated.concat(created);
            const removals = additions.concat(deleted).map((e) => e.id);
            const next = state[action.payload.propertyId];
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: next.filter((evt) => removals.indexOf(evt.id) === -1).concat(additions) });
        case 'AVAILABILITY_EVENT_DELETE_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: state[action.payload.propertyId].filter((events) => events.id !== action.payload.availabilityEvent.id) });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map